<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/dudao/renyuan' }">人员管理</el-breadcrumb-item>
      <el-breadcrumb-item>添加员工</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图区 -->
    <el-card class="box-card">
      <div slot="header" class="flexContainer">
        <span class="cardHeader">添加员工</span>
      </div>

      <el-form :model="form" ref="formRef" :rules="formRules" label-width="100px" :inline="false" size="normal" style="max-width:600px">
        <el-form-item label="姓名：" prop="name">
          <el-input v-model="form.name" placeholder="请输入员工姓名，2-15个字符"></el-input>
        </el-form-item>

        <el-form-item label="性别：" prop="sex">
          <el-radio-group v-model="form.sex">
            <el-radio label="男">男</el-radio>
            <el-radio label="女">女</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="身份证号：" prop="idCard">
          <el-input v-model="form.idCard" placeholder="请输入身份证号（选填）"></el-input>
        </el-form-item>

        <el-form-item label="手机号：" prop="mobile">
          <el-input v-model="form.mobile" placeholder="请输入手机号（选填）"></el-input>
        </el-form-item>

        <el-form-item label="部门：" prop="department">
          <el-select v-model="form.department" placeholder="请选择部门" style="width: 100%">
            <el-option v-for="dept in departmentList" :key="dept._id" :label="dept._id" :value="dept._id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="职位：" prop="job">
          <el-select v-model="form.job" placeholder="请选择职位" style="width: 100%">
            <el-option v-for="job in jobList" :key="job" :label="job" :value="job"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="入职时间：" prop="inDate">
          <el-date-picker
            v-model="form.inDate"
            type="date"
            placeholder="请选择入职时间"
            value-format="yyyy-MM-dd"
            style="width: 100%">
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="okClickHandler">添加员工</el-button>
          <el-button @click="goBack">返回</el-button>
        </el-form-item>
      </el-form>

    </el-card>

  </div>
</template>

<script>
import { dudaoJobList } from '@/utility/staticData'
export default {
  data () {
    // 手机号验证
    const validateMobile = (rule, value, callback) => {
      if (value && !/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }

    // 身份证号验证
    const validateIdCard = (rule, value, callback) => {
      if (value && !/^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/.test(value)) {
        callback(new Error('请输入正确的身份证号'))
      } else {
        callback()
      }
    }

    return {
      // 表单数据
      form: {
        name: '', // 员工姓名
        sex: '男', // 性别：男/女
        idCard: '', // 身份证号
        mobile: '', // 手机号
        department: '', // 部门ID
        job: '', // 职位
        inDate: '' // 入职时间
      },
      // 部门列表
      departmentList: [],
      // 岗位列表
      jobList: dudaoJobList,

      // 表单验证规则
      formRules: {
        name: [
          { type: 'string', required: true, message: '请输入员工姓名', trigger: 'blur' },
          { type: 'string', min: 2, max: 15, message: '姓名必须为2-15个字符', trigger: 'blur' }
        ],
        sex: [
          { required: true, message: '请选择性别', trigger: 'change' }
        ],
        idCard: [
          { validator: validateIdCard, trigger: 'blur' }
        ],
        mobile: [
          { validator: validateMobile, trigger: 'blur' }
        ],
        department: [
          { required: true, message: '请选择部门', trigger: 'change' }
        ],
        job: [
          { type: 'string', required: true, message: '请输入职位', trigger: 'blur' }
        ],
        inDate: [
          { required: true, message: '请选择入职时间', trigger: 'change' }
        ]
      }
    }
  },
  created () {
    this.getDepartmentList()
  },
  methods: {
    // 获取部门列表
    async getDepartmentList () {
      const { data: res } = await this.$http.get('dudao/department/list')
      if (res.meta.status !== 200) {
        return this.$message.error(res.meta.msg)
      }
      this.departmentList = res.data
    },

    // 点击添加按钮
    async okClickHandler () {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return false

        const { data: res } = await this.$http.post('dudao/renyuan/add', this.form)
        if (res.meta.status !== 200) return this.$message.error(res.meta.msg)
        this.$message.success(res.meta.msg)
        this.goBack()
      })
    },

    // 返回
    goBack () {
      this.$router.push('/dudao/renyuan')
    }
  }
}
</script>

<style lang="less" scoped>

</style>
